module.exports = __webpack_public_path__ + "static/media/usecase.f28d8172.png";